
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import { mapGetters } from 'vuex';

export default {
name: 'ProductDetailPC',
data() {
return {
showValue: '查看更多',
position: 'top',
hiddenValue: false,
model: 0,
index: 0,
show: false,
curName: '',
pordDetailPicture: [],
check: true,
flavourList: [],
flavour: '',
specList: [],
spec: '',
picture_list: [],
picture_unit_list: [],
price: 0,
unit: '',
price2: 0,
unit2: '',
prod: {
categoryId: '',
categoryName: '',
prodId: '',
prodName: '',
discription: [],
productList: [],
},
ProdMsg: [],
showMsg: [],
message: null,
adPathShow: false,
videoList: [],
bottomImg: '',
setting: {
value: 0,
autoplay: false,
autoplaySpeed: 1500,
dots: 'inside',
radiusDot: true,
trigger: 'click',
arrow: 'always',
},
setting2: {
autoplay: false,
autoplaySpeed: 3000,
dots: 'none',
radiusDot: true,
trigger: 'click',
arrow: 'always',
},
}
},
components: {
Checker,
CheckerItem,
},
directives: {
TransferDom,
},
computed: {
...mapGetters([ 'thirdParty' ]),
isShowLink() {
return !(['20', '23'].includes(this.$route.query.categoryId) && this.thirdParty === '1')
},
},
watch: {

'$route.query': {
handler(newVal) {
if ('thirdParty' in newVal)  {
this.$store.replaceState({
thirdParty: newVal.thirdParty,
});
}
},
immediate: true
}
},
mounted() {
this.$el.querySelector('.pc-detail-icon').scrollIntoView()
if (this.$route.params.productList) {
this.loadProdMsg(this.$route.params, null)
} else {
let categoryId = sessionStorage.getItem('categoryId')
let prodId = sessionStorage.getItem('prodId')
if (!categoryId && !prodId) {
categoryId = this.$route.query.categoryId
prodId = this.$route.query.prodId
}
this.getProdDetail(categoryId, prodId)
}
},
methods: {
loadProdMsg(ProdMsg, type) {
if (type != 'icon') {
this.prod.productList = ProdMsg.productList
}

this.prod.categoryName = ProdMsg.product[0].categoryName
this.prod.categoryId = ProdMsg.product[0].categoryId
this.prod.prodId = ProdMsg.product[0].prodId
this.prod.prodName = ProdMsg.product[0].prodName
this.curName = ProdMsg.product[0].prodName

this.pordDetailPicture = ProdMsg.productPicture

this.flavourList = ProdMsg.product[0].productFlavour
this.flavour = this.flavourList[0].flavour

this.specList = this.flavourList[0].productDetail.sort((a, b) => {
if (a.salePrice > b.salePrice) {
return 1
} else {
return -1
}
})

let specObj = this.specList[0]
this.spec = specObj.spec

this.prod.discription = specObj.discription.split('!@')

let spec_img_list = specObj.productPicture
let spec_unit_img_list = specObj.productUnitPicture
this.picture_list = []
this.picture_unit_list = []
let _this = this
spec_img_list.forEach((item) => {
let picture = { img: item.picturePath }
_this.picture_list.push(picture)
})
spec_unit_img_list.forEach((item) => {
let picture = { img: item.picturePath }
_this.picture_unit_list.push(picture)
})

this.price = specObj.salePrice
this.unit = specObj.unit
this.price2 = specObj.salePrice2
this.unit2 = specObj.unit2
if (ProdMsg.productAdvert.length > 0) {
this.videoList = ProdMsg.productAdvert
this.bottomImg = ProdMsg.productAdvert[0].adPreviewPc
this.adPathShow = ProdMsg.productAdvert[0].adPath ? true : false
}
},
queryMore() {
if (this.showValue == '收起') {
this.showValue = '查看更多'
this.model = 0
} else {
this.showValue = '收起'
this.model = -100
}
},
queryProdItem(item, idx) {
this.index = idx
this.getProdItemDetail(this.prod.categoryId, item.prodId)
},
getProdItemDetail(categoryId, prodId) {
let url = `${this.API_ROOT}queryProductDetailById`
this.$http({
method: 'get',
url: url,
params: {
categoryId: categoryId,
prodId: prodId,
},
}).then(
(res) => {
if (res.data.mapDatas) {
this.loadProdMsg(res.data.mapDatas, 'icon')
} else {
alert('返回数据为空,请联系管理员检查')
}
},
(er) => {
console.log(er)
alert('请求失败')
}
)
},
searchProdItem() {
if (this.message) {
this.queryProductByName(this.message)
} else {
this.show = false
this.showMsg = []
}
},
queryProductByName(prodName) {
let url = `${this.API_ROOT}queryProductByName`
let data = {}
if (prodName) {
data = { prodName: prodName }
}
this.$http({
method: 'get',
url: url,
params: data,
}).then(
(res) => {
if (prodName) {
if (res.data.datas.length > 0) {
this.showMsg = res.data.datas
this.show = true
}
}
},
(er) => {
console.log(er)
alert('请求失败')
}
)
},
getProdDetail(categoryId, prodId) {
let url = `${this.API_ROOT}queryProductDetailById`
this.$http({
method: 'get',
url: url,
params: {
categoryId: categoryId,
prodId: prodId,
},
}).then(
(res) => {
if (res.data.mapDatas) {
this.message = null
this.showMsg = []
this.show = false
let arr = res.data.mapDatas
arr.productList.forEach((item, index) => {
if (prodId == item.prodId && index > 0) {
res.data.mapDatas.productList.splice(index, 1)
res.data.mapDatas.productList.unshift(item)
}
})
this.loadProdMsg(res.data.mapDatas, null)
} else {
alert('返回数据为空,请联系管理员检查')
}
},
(er) => {
console.log(er)
alert('请求失败')
}
)
},
goPC() {
this.$router.push({ name: 'ProductPC', params: { categoryId: this.prod.categoryId } })
},
onSearch() {
if (this.showMsg.length > 0 && this.showMsg[0].prodName === this.message) {
this.getProdDetail(this.showMsg[0].categoryId, this.showMsg[0].prodId)
} else {
if (this.message) {
this.show = false
this.showMsg = []
alert('查无数据！')
} else {
alert('请输入要查询的数据！')
}
}
},
onTasteClick(value, disabled) {
this.specList = value.productDetail.sort((a, b) => {
if (a.salePrice > b.salePrice) {
return 1
} else {
return -1
}
})
this.onStandardClick(this.specList[0])
this.spec = this.specList[0].spec
},
onStandardClick(value, disabled) {
this.picture_list = []
this.picture_unit_list = []
this.setting.value = 0
this.prod.discription = value.discription.split('!@')
this.price = value.salePrice
this.unit = value.unit
this.price2 = value.salePrice2
this.unit2 = value.unit2
if (value.productPicture && value.productPicture.length > 0) {
let _this = this
value.productPicture.forEach((item) => {
let picture = { img: item.picturePath }
_this.picture_list.push(picture)
})
}
if (value.productUnitPicture && value.productUnitPicture.length > 0) {
let _this = this
value.productUnitPicture.forEach((item) => {
let picture = { img: item.picturePath }
_this.picture_unit_list.push(picture)
})
}
},
gotoBuy(type) {
if (type === 'JD') {
window.open('https://wangwangshipin.jd.com/')
} else if (type === 'TM') {
window.open('https://wangwangshipin.tmall.com/?spm=687.8433302/new.33000091006.1.296f226aTJllT8')
} else {
window.open('https://srv.hotkidceo.com/store/?utm_source=untrack#/')
}
},
backTop() {
document.body.scrollTop = 0
document.documentElement.scrollTop = 0
}
},
}



// WEBPACK FOOTER //
// ./src/components/ProductDetailPC.vue